/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/house_2_medium'
export default icon
